/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./styles/common.css";
// import "./styles/styles.less";
import { Layout } from "antd";
import { RootStore } from "./stores/rootStore.js";
import { observer } from "mobx-react";
import { PATH_NAME } from "./utils";
import SideMenu from "./components/sideMenu";
import NavHeader from "./components/navHeader";
import routes,{routerList} from "./router-config";
import { PageLoading } from "./components/pageLoading";

const { Scrollbars } = require("react-custom-scrollbars");

interface IRoutingState { }

interface IRoutingProps {
	rootStore: RootStore;
}

@observer
class Routing extends React.Component<IRoutingProps, IRoutingState> {
	static getDefaultPath = () => {
		const pathname = window.location.pathname;
		if (!pathname || pathname === "/") {
			return PATH_NAME.HOME_PAGE;
		}
		return pathname;
	};

	constructor(props: any) {
		super(props);
		let collapsed = window.innerWidth > 1200 ? false : true;
		this.state = {
			isCollapsed: collapsed,
		};
	}

	render() {
		const { rootStore } = this.props;
		const { Content, Sider } = Layout;
		return (
			<Router>
				<Layout className="content-container" >
					<Sider className="layout-sider" breakpoint="xl" trigger={null} theme="light" width="240" collapsedWidth="60px" collapsible ><SideMenu web3Store={rootStore.web3Store} routes={routes}/></Sider>
					<Content>
						<NavHeader web3Store={rootStore.web3Store}/>
						<Scrollbars className="main-scrollbars" style={{width:"100%",height:"calc(100% - 64px)"}}>
						<PageLoading />
						<Switch>
							{routerList.filter((item) => !item.isLink).map((route: any, index) => {
								return (
									<Route
										key={index}
										path={route.path}
										render={() => (
											<route.component
												web3Store={
													rootStore.web3Store
												}
												rootStore={rootStore}
											/>
										)}
									/>
								);
							}
							)}
						</Switch>
						</Scrollbars>
					</Content>
				</Layout>
			</Router>
		);
	}
}

export default Routing;
